import types from './types';

const getEntitiesRequest = () => ({
  type: types.GET_ENTITIES_REQUEST
});

const getEntitiesSuccess = (entities) => ({
  type: types.GET_ENTITIES_SUCCESS,
  entities
});

const getEntitiesFailure = (error) => ({
  type: types.GET_ENTITIES_FAILURE,
  error
});

const createEntityRequest = (entity) => ({
  type: types.CREATE_ENTITY_REQUEST,
  entity
});

const createEntitySuccess = () => ({
  type: types.CREATE_ENTITY_SUCCESS
});

const createEntityFailure = (error) => ({
  type: types.CREATE_ENTITY_FAILURE,
  error
});

const updateEntityRequest = (id, entity, version) => ({
  type: types.UPDATE_ENTITY_REQUEST,
  id,
  entity,
  version
});

const updateEntitySuccess = (id) => ({
  type: types.UPDATE_ENTITY_SUCCESS,
  id
});

const updateEntityFailure = (id, error) => ({
  type: types.UPDATE_ENTITY_FAILURE,
  id,
  error
});

const deleteEntityRequest = (id, version) => ({
  type: types.DELETE_ENTITY_REQUEST,
  id,
  version
});

const deleteEntitySuccess = (id) => ({
  type: types.DELETE_ENTITY_SUCCESS,
  id
});

const deleteEntityFailure = (id, error) => ({
  type: types.DELETE_ENTITY_FAILURE,
  id,
  error
});

const subscribeEntities = () => ({
  type: types.SUBSCRIBE_ENTITIES
});

const unsubscribeEntities = () => ({
  type: types.UNSUBSCRIBE_ENTITIES
});

const subscriptionEntityCreated = (createdEntity) => ({
  type: types.SUBSCRIPTION_ENTITY_CREATED,
  createdEntity
});

const subscriptionEntityUpdated = (updatedEntity) => ({
  type: types.SUBSCRIPTION_ENTITY_UPDATED,
  updatedEntity
});

const subscriptionEntityDeleted = (deletedEntity) => ({
  type: types.SUBSCRIPTION_ENTITY_DELETED,
  deletedEntity
});

export default {
  getEntitiesRequest,
  getEntitiesSuccess,
  getEntitiesFailure,
  createEntityRequest,
  createEntitySuccess,
  createEntityFailure,
  updateEntityRequest,
  updateEntitySuccess,
  updateEntityFailure,
  deleteEntityRequest,
  deleteEntitySuccess,
  deleteEntityFailure,
  subscribeEntities,
  unsubscribeEntities,
  subscriptionEntityCreated,
  subscriptionEntityUpdated,
  subscriptionEntityDeleted
};
